/**
 * Bytes pipe
 *
 * @version
 * 4.36.0 OAUI-510 Add / Edit / Remove Attachments
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2022 Build Centrix
 */
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'BcxBytes',
})
export class BcxBytesPipe implements PipeTransform {
  /**
   * Pipe Transform bytes into human readable string
   * i.e. 1GB, 320KB
   * @since 4.36.0
   */
  transform(bytes: number): string {
    let bytesValue = '0';
    let bytesString = '';

    if (bytes) {
      const precision = 1;
      const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
      const number = Math.floor(Math.log(bytes) / Math.log(1024));

      bytesString = units[number];
      bytesValue = (bytes / Math.pow(1024, Math.floor(number))).toFixed(
        precision,
      );
    }

    return [bytesValue, bytesString].join(' ');
  }
}
